module.exports = __webpack_public_path__ + "static/media/DsDataset.cc188fac.svg";